<template>
  <div class="trans-record-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('账户明细') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <!-- 筛选条件 -->
      <div class="saibox">
        <div :class="{'sai': true, 'active': showXuan === 1 }" @click="showPopup(1)">{{ name }}</div>
        <div :class="{'sai': true, 'active': showXuan === 2 }" @click="showPopup(2)">{{ dateName[date] }}</div>
        <div :class="{'sai': true, 'active': showXuan === 3 }" @click="showPopup(3)">{{ typeName[type] }}</div>
      </div>
      <van-list style="margin-top: 10px; padding-bottom: 120px" :finished-text="$t('没有更多了')" offset="300" v-model="loading" :finished="list.length == pageData.total" @load="getData" v-if="list.length > 0">
        <van-cell v-for="(item, index) in list" :key="index">
          <div style="font-size: 0.32rem; color: #fff;" v-if="type == 1 || type == 2">{{ $t('订单号') }}：{{ item.out_trade_no }}</div>
          <div style="display: flex; justify-content: space-between;">
            <div style="font-size: 0.32rem;color: #fff;">{{ $t('金额') }} :{{ item.amount }}</div>
            <div style="font-size: 0.32rem;color: #fff;">{{ item.pay_way }}</div>
            <div style="font-size: 0.32rem;color: #fff;">{{ type == 1 || type == 2 ? stateType12[item.state] : stateType34[item.state] }}</div>
          </div>
          <div style="font-size: 0.32rem;color: #fff;">{{ item.created_at }}</div>
        </van-cell>
      </van-list>
      <div v-else style="margin-top: 3rem; text-align: center">
        <img src="/static/image/new/mine/mescroll-empty.png" style="width: 3.68rem;" alt="" />
        <div style="font-size: .37rem;color: #999;margin-top: .43rem">{{ $t('空空如也') }}</div>
      </div>
    </div>
    <!-- 弹出层 -->
    <van-popup v-model="popup" position="bottom" :style="{ height: 'calc(100% - 1.9rem - 46px)' }">
      <div class="lisg" v-if="showXuan == 1">
        <div class="bs" v-for="(item, index) in dogameLis" :key="index" @click="changDogame(item.name, item.platname)">
          <div :class="api_type == item.platname ? 'lisga act' : 'lisga'">{{ item.name }}</div>
        </div>
      </div>
      <div class="lisg" v-if="showXuan == 2">
        <div class="bs" @click="changtype('date', 1)">
          <div :class="date == 1 ? 'lisga act' : 'lisga'">{{ $t('今日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 2)">
          <div :class="date == 2 ? 'lisga act' : 'lisga'">{{ $t('近7日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 3)">
          <div :class="date == 3 ? 'lisga act' : 'lisga'">{{ $t('近15日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 4)">
          <div :class="date == 4 ? 'lisga act' : 'lisga'">{{ $t('近30日') }}</div>
        </div>
      </div>
      <div class="lisg" v-if="showXuan == 3">
        <div class="bs" @click="changtype('type', 1)">
          <div :class="type == 1 ? 'lisga act' : 'lisga'">{{ $t('存款') }}</div>
        </div>
        <div class="bs" @click="changtype('type', 2)">
          <div :class="type == 2 ? 'lisga act' : 'lisga'">{{ $t('取款') }}</div>
        </div>
        <div class="bs" @click="changtype('type', 3)">
          <div :class="type == 3 ? 'lisga act' : 'lisga'">{{ $t('转入') }}</div>
        </div>
        <div class="bs" @click="changtype('type', 4)">
          <div :class="type == 4 ? 'lisga act' : 'lisga'">{{ $t('转出') }}</div>
        </div>
        <div class="bs" @click="changtype('type', 5)">
          <div :class="type == 5 ? 'lisga act' : 'lisga'">{{ $t('赠送') }}</div>
        </div>
        <div class="bs" @click="changtype('type', 6)">
          <div :class="type == 6 ? 'lisga act' : 'lisga'">{{ $t('反水') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'transRecord',
  data() {
    return {
      date: 4,
      list: [],
      pageData: {},
      type: 1,
      page: 1,
      stateType12: [this.$t('未定义'), this.$t('待审核'), this.$t('审核通过'), this.$t('审核拒绝')],
      stateType34: [this.$t('失败'), this.$t('成功'), this.$t('待结算'), this.$t('未定义')],
      dogameLis: [],
      api_type: '',
      loading: false,
      name: this.$t('全平台'),
      dateName: ['', this.$t('今日'), this.$t('近7日'), this.$t('近15日'), this.$t('近30日')],
      typeName: ['', this.$t('存款'), this.$t('取款'), this.$t('转入'), this.$t('转出'), this.$t('赠送'), this.$t('反水')],

      popup: false,
      showXuan: 1, //1平台选择 2 日期选择
    };
  },
  created() {
    let that = this;
    that.getdogame();
    that.getData();
  },
  methods: {
    changDogame(name, type) {
      let that = this;
      that.name = name;
      that.api_type = type;
      that.popup = false;
      that.page = 1;
      that.getData();
    },
    changtype(name, val) {
      let that = this;
      that[name] = val;
      that.popup = false;
      that.page = 1;
      that.getData();
    },
    showPopup(val) {
      this.popup = true;
      this.showXuan = val;
    },
    openOrclose() {
      this.show = !this.show;
    },
    changtab() {
      let that = this;
      that.page = 1;
      that.list = [];
      that.pageData = {};
      that.getData();
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(async (res) => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          const list = res.data
          const name_arr = []
          for (let i = 0; i < list.length; i++) {
            name_arr.push(list[i].name)
          }
          const text = await translateText(name_arr);
          text.forEach((item, index) => {
            list[index].name = item
          })

          that.dogameLis = list;
          that.dogameLis.unshift({ name: this.$t('全平台'), platname: '' });
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getData();
    },

    // 获取交易记录
    getData() {
      let that = this;
      let page = that.page;
      if (page > that.pageData.last_page) {
        that.loading = false;

        return;
      }
      that.$parent.showLoading();
      let info = {
        date: that.date,
        type: that.type,
        page: that.page,
        api_type: that.api_type,
      };
      that.$apiFun
        .post('/api/gettransrecord', info)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data;
            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.trans-record-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 0 .4rem;
    .saibox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      box-sizing: border-box;
      margin: .2rem 0;
      .sai {
        width: 2.88rem;
        height: 1.07rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.10);
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .21rem;
        font-size: 0.43rem;
        &.active {
          background: linear-gradient(to bottom, #2E0B71 40%, #7214D7);
          border-color: #2E0B71;
          font-weight: bold;
        }
      }
    }
  }
  .van-popup {
    background: #191919 !important;
    border: .03rem solid rgba(255, 255, 255, 0.10);
  }
  .lisg {
    box-sizing: border-box;
    padding: .32rem .4rem;
    display: flex;
    flex-wrap: wrap;
    .bs {
      width: 2.08rem;
      height: 1.07rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: .2rem;
      margin-right: .26rem;
      &:nth-child(4n+4) {
        margin-right: 0;
      }
      .lisga {
        width: 100%;
        padding: 0 .1rem;
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .21rem;
        height: 100%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.37rem;
        text-align: center;
      }
      .lisga.act {
        background: linear-gradient(to bottom, #2E0B71 40%, #7214D7);
        border-color: #2E0B71;
      }
    }
  }

  .van-cell {
    background: rgba(255, 255, 255, 0.10);
    border: 0.03rem solid rgba(255, 255, 255, 0.10);
    margin-bottom: .27rem;
    color: #fff;
    padding: .2rem;
    border-radius: .19rem;
    &::after {
      border: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/transRecord.vue